import React from "react";
import { Navigate, Outlet, Route, useParams } from "react-router-dom";

import AppErrorComponent from "AppErrorComponent";
import ErrorBoundary from "lib/ErrorBoundary";
import { DDRoute } from "lib/Datadog";
import {
  NotFoundNavigation,
  NotFoundRedirectRoutes,
} from "components/NotFound";
import { PurchaseOrderOverviewNavigation } from "components/PurchaseOrder";

import {
  basePath,
  idParamName,
  idPath,
  overviewPath,
  productsPath,
  purchaseOrderOverviewRoute,
  purchaseOrderProductsRoute,
} from "./paths";

const BaseRoute = () => {
  const id = useParams<{ [idParamName]: string }>()[idParamName];
  return !id || isNaN(Number(id)) ? (
    <NotFoundNavigation />
  ) : (
    <ErrorBoundary FallbackComponent={AppErrorComponent}>
      <Outlet />
    </ErrorBoundary>
  );
};

const Overview = React.lazy(() => import("Workspace/Overview"));
const OverviewRoute = () => (
  <DDRoute view={purchaseOrderOverviewRoute} children={<Overview />} />
);

const Products = React.lazy(() => import("Workspace/Products"));
const ProductsRoute = () => (
  <DDRoute view={purchaseOrderProductsRoute} children={<Products />} />
);

/**
 * This is intentionally NOT a component.
 * All component children of <Routes> must be a <Route> or <React.Fragment>.
 */
export const Routes = (
  <>
    <Route path="assortments/" element={<Outlet />}>
      <Route path={idPath} element={<Outlet />}>
        <Route index element={<PurchaseOrderOverviewNavigation />} />
        <Route path="*" element={<PurchaseOrderOverviewNavigation />} />
      </Route>
      {NotFoundRedirectRoutes /* MUST BE LAST! see `NotFoundRedirectRoutes`*/}
    </Route>
    <Route path={basePath} element={<Outlet />}>
      <Route path={idPath} element={<BaseRoute />}>
        <Route path={overviewPath} element={<OverviewRoute />} />
        <Route path={productsPath} element={<ProductsRoute />} />
        <Route path="*" element={<Navigate to={overviewPath} replace />} />
        <Route index element={<Navigate to={overviewPath} replace />} />
      </Route>
      {NotFoundRedirectRoutes /* MUST BE LAST! see `NotFoundRedirectRoutes`*/}
    </Route>
  </>
);
